import React from 'react'

import SectionDescription from './SectionDescription'
import SectionTitle from './SectionTitle'

interface SectionHeaderProps {
  title?: string
  titleClassName?: string
  description?: string
  className?: string
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  titleClassName,
  description,
  className,
}) => (
  <div className={className}>
    <SectionTitle title={title} className={titleClassName} />
    <SectionDescription description={description} />
  </div>
)

export default SectionHeader
